import { render, staticRenderFns } from "./organizational-structure-setting.vue?vue&type=template&id=c9a97e62&scoped=true&"
import script from "./organizational-structure-setting.vue?vue&type=script&lang=js&"
export * from "./organizational-structure-setting.vue?vue&type=script&lang=js&"
import style0 from "./organizational-structure-setting.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./organizational-structure-setting.vue?vue&type=style&index=1&id=c9a97e62&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a97e62",
  null
  
)

export default component.exports